import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=754a38aa&scoped=true&"
import script from "./Notification.vue?vue&type=script&lang=ts&"
export * from "./Notification.vue?vue&type=script&lang=ts&"
import style0 from "./Notification.vue?vue&type=style&index=0&id=754a38aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754a38aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('754a38aa')) {
      api.createRecord('754a38aa', component.options)
    } else {
      api.reload('754a38aa', component.options)
    }
    module.hot.accept("./Notification.vue?vue&type=template&id=754a38aa&scoped=true&", function () {
      api.rerender('754a38aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/Notification.vue"
export default component.exports